import styled from 'styled-components';
import { RiCloseLine } from 'react-icons/ri';
import { FiMenu } from 'react-icons/fi';
import { RiArrowDownSLine } from 'react-icons/ri';
// import { HiOutlineMenu } from 'react-icons/hi';

export const HeaderOuter = styled.div`
  position: ${({ fixed }) => (fixed ? 'fixed' : 'absolute')};
  top: 0px;
  background: ${({ variant, isFromInterview, isDashboard, theme }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : isFromInterview
      ? 'var(--btnDarkTxt)'
      : isDashboard
      ? theme.pageBg
      : 'var(--siteBgColor)'};
  width: 100%;
  height: var(--headerHeight);
  z-index: 1100;
  box-shadow: ${({ isScrolling }) => (isScrolling ? '0px 1px 4px var(--greyShadowColor)' : 'none')};
  border-bottom: ${({ isDashboard, theme }) => isDashboard && `1px solid ${theme.borderColor}`};
  transform: ${({ headerOfferSnackbar, showTrialExpiredBar }) =>
    headerOfferSnackbar && showTrialExpiredBar
      ? 'translateY(calc(var(--topOfferSnackbarHeight) + var(--trialSnackbarHeight)))'
      : headerOfferSnackbar
      ? 'translateY(var(--topOfferSnackbarHeight))'
      : showTrialExpiredBar
      ? 'translateY(var(--trialSnackbarHeight))'
      : 'translateY(0px)'};
`;

export const HeaderInner = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => (props.isDashboard ? '0px 8px' : '0px 16px')};
  @media (min-width: 320px) {
    padding: ${(props) => props.isDashboard && '0px 16px'};
  }
  @media (min-width: 992px) {
    width: ${(props) => (props.isDashboard ? '100%' : 'var(--layoutWidth)')};
    padding: ${(props) => (props.isDashboard ? '0px 16px' : '0px')};
  }
  @media (min-width: 1200px) {
    width: ${(props) => (props.isDashboard ? '100%' : 'var(--layoutWidth)')};
  }
  @media (min-width: 1400px) {
    max-width: ${(props) => (props.isDashboard ? 'none' : '1400px')};
  }
`;

export const HeaderLogoIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: inline-flex;
  @media (min-width: 768px) {
    width: 25px;
    height: 25px;
  }
  @media (min-width: 1200px) {
    width: 27px;
    height: 27px;
  }
  @media (min-width: 1400px) {
    width: 30px;
    height: 30px;
  }
`;

export const HeaderLogoText = styled.h4`
  color: ${({ darkTheme }) => (darkTheme ? '#fff' : '#2575fc')};
  padding-bottom: unset;
  padding-left: 6px;
  font-size: 16px !important;
  line-height: normal;
  @media (min-width: 768px) {
    font-size: 17px !important;
  }
  @media (min-width: 1200px) {
    font-size: 18px !important;
  }
`;

export const HeaderLogoWrapper = styled.div`
  width: 125px;
  padding: 4px 0px;
  @media (min-width: 300px) {
    width: 140px;
  }
  @media (min-width: 768px) {
    width: 150px;
  }
  @media (min-width: 1200px) {
    width: 160px;
  }
  @media (min-width: 1400px) {
    width: 170px;
  }
`;

export const HeaderNavBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  background: transparent;
  @media (min-width: 992px) {
    margin-left: 8px;
  }
`;

export const HeaderItem = styled.div`
  display: none;
  cursor: pointer;
  color: ${({ variant, isFromInterview, theme, isDashboard }) =>
    variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors'
      ? '#fff'
      : isFromInterview
      ? 'var(--light)'
      : isDashboard
      ? theme.txtPrimary
      : 'var(--normalTxtColor)'};
  @media (min-width: 992px) {
    display: inline-flex;
    align-items: center;
    padding: 18px 0px;
    margin-left: ${({ noMargin }) => !noMargin && '14px'};
  }
`;

export const HeaderLink = styled.a`
  display: ${({ mobileLink, desktopLink }) => (mobileLink ? 'inline-flex' : desktopLink ? 'none' : 'inline-flex')};
  align-items: center;
  color: ${({ variant, isFromInterview, darkTheme }) =>
    variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '#fff' : isFromInterview || darkTheme ? 'var(--light)' : 'var(--normalTxtColor)'};
  margin-left: ${({ noMargin }) => !noMargin && '14px'};
  padding: 5px 0px;
  @media (min-width: 992px) {
    display: ${({ mobileLink, desktopLink }) => (mobileLink ? 'none' : desktopLink ? 'inline-flex' : 'inline-flex')};
  }
  :hover {
    color: ${({ variant, isFromInterview, darkTheme }) =>
      variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '#fff' : isFromInterview || darkTheme ? 'var(--light)' : 'var(--normalTxtColor)'};
    opacity: 0.8;
  }
`;

// mobile side menu (z-index value higher than Header)
export const MobNav = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  height: ${({ headerOfferSnackbar, showTrialExpiredBar }) =>
    headerOfferSnackbar && showTrialExpiredBar
      ? 'calc(100vh - calc(var(--topOfferSnackbarHeight) + var(--trialSnackbarHeight)))'
      : headerOfferSnackbar
      ? 'calc(100vh - var(--topOfferSnackbarHeight))'
      : showTrialExpiredBar
      ? 'calc(100vh - var(--trialSnackbarHeight))'
      : '100vh'};
  transform: ${({ headerOfferSnackbar, showTrialExpiredBar }) =>
    headerOfferSnackbar && showTrialExpiredBar
      ? 'translateY(calc(var(--topOfferSnackbarHeight) + var(--trialSnackbarHeight)))'
      : headerOfferSnackbar
      ? 'translateY(var(--topOfferSnackbarHeight))'
      : showTrialExpiredBar
      ? 'translateY(var(--trialSnackbarHeight))'
      : 'unset'};
  z-index: 3000;
  @media (min-width: 992px) {
    display: none;
  }
`;

export const MobileHeader = styled.div`
  position: sticky;
  top: 0px;
  width: 100%;
  height: 55px;
  padding: 4px 16px 4px 16px;
  display: flex;
  align-items: center;
  background: ${({ variant, isFromInterview, theme, isDashboard }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsColor)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : isFromInterview
      ? 'var(--btnDarkTxt)'
      : isDashboard
      ? theme.pageBg
      : 'white'};
  box-shadow: 0px 1px 1px ${({ isFromInterview, theme, isDashboard }) => (isFromInterview ? '#ffffff33' : isDashboard ? theme.borderColor : 'var(--greyShadowColor)')};
  @media (min-width: 768px) {
    height: 60px;
  }
  @media (min-width: 992px) {
    display: none;
  }
`;

export const MobileHeaderLogoWrapper = styled.div`
  width: 140px;
  padding: 4px 0px;
  @media (min-width: 768px) {
    width: 150px;
  }
`;

export const CloseIcon = styled(RiCloseLine)`
  font-size: 26px;
  cursor: pointer;
  color: ${({ isFromInterview }) => (isFromInterview ? 'var(--brandColor)' : 'var(--secondary)')};
`;

export const MobList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 5px 0px 0px 0px;
`;

export const MobItem = styled.li`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  color: ${({ theme, isDashboard }) => isDashboard && theme.txtPrimary};
  cursor: ${({ nonClickable }) => (nonClickable ? 'default' : 'pointer')};
`;

export const MobLink = styled.a`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 20px;
  font-size: 16px;
  color: ${({ isFromInterview }) => (isFromInterview ? 'var(--light)' : 'var(--normalTxtColor)')};
  :hover {
    color: ${({ isFromInterview }) => (isFromInterview ? 'var(--light)' : 'var(--normalTxtColor)')};
    opacity: 0.8;
  }
`;

export const MobSideMenuIcons = styled.img`
  width: 22px;
  margin-right: 12px;
`;

export const HamburgerIcon = styled(FiMenu)`
  font-size: 25px;
  margin-right: 12px;
  cursor: pointer;
  color: ${({ variant, isFromInterview, isDashboard, darkTheme }) =>
    variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors'
      ? 'var(--light)'
      : isFromInterview || (isDashboard && darkTheme)
      ? 'var(--greyBgLight)'
      : 'var(--secondary)'};
`;

export const DboardHamburgerWrapper = styled.div`
  width: 25px;
  height: 25px;
  font-size: 25px;
  display: grid;
  place-items: center;
  margin-right: 12px;
  margin-left: 3px;
  cursor: pointer;
  color: ${({ darkTheme }) => (darkTheme ? 'var(--greyBgLight)' : 'var(--secondary)')};
`;

export const ThemeOptions = styled.div`
  display: none;
  margin-right: 12px;
  @media (min-width: 300px) {
    display: flex;
    align-items: center;
  }
`;

export const SideNavDropDownIcon = styled(RiArrowDownSLine)`
  font-size: 20px;
  color: ${({ theme }) => theme.txtPrimary};
`;

export const HrTag = styled.hr`
  margin-top: ${({ marginValue }) => (marginValue ? `${marginValue} !important` : '1rem !important')};
  margin-bottom: ${({ marginValue }) => (marginValue ? `${marginValue} !important` : '1rem !important')};
  border-top: 1px solid ${({ darkTheme }) => (darkTheme ? 'var(--inputTxtColor)' : '#0000001a')};
`;

export const HeaderGoldBtn = styled.button.attrs({ className: 'goldPassBtn' })`
  min-width: 95px;
  font-size: 15px;
  font-weight: 600;
  padding: 4px 8px;
  line-height: normal;
  color: var(--goldPassColor);
  background: transparent;
  border: 2px solid var(--goldPassColor);
  border-radius: 25px;
  outline: none;
  :hover {
    filter: brightness(97%);
    outline: none;
  }
  :active {
    filter: initial;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

// dashboard user options
export const HeaderUserOptionsToggle = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  margin-left: 12px;
  cursor: pointer;
  outline: none;
  @media (min-width: 320px) {
    margin-left: 14px;
  }
  @media (min-width: 576px) {
    width: 32px;
    height: 32px;
    margin-left: 16px;
  }
`;

export const HeaderUserOptionsWrapper = styled.div`
  position: absolute;
  top: 48px;
  right: 0px;
  width: 200px;
  padding: 6px 0px;
  border-radius: var(--buttonRadius);
  background-color: ${(props) => props.theme.pageBg};
  border: 1px solid ${(props) => props.theme.borderColor};
  z-index: 80;
`;
